exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badgefilter[data-v-66ab8e44]{display:inline-block;padding:5px;font-size:12px;font-weight:400;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.7rem}.close[data-v-66ab8e44]:focus,.close[data-v-66ab8e44]:hover{color:#000;text-decoration:none;opacity:.75}.close[data-v-66ab8e44]{float:right;font-size:1rem;color:#fff;text-shadow:0 1px 0 #fff;opacity:1;margin-left:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66ab8e44","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bar-list.vue
// module id = 1108
// module chunks = 0